import { useEffect, useState } from "react";
import { Flex, Text, Icon } from "@chakra-ui/react";
import { CheckCircle2 } from "lucide-react";
import { colors } from "@/theme/colors";

let pushToast = null;
export const showToast = (title) => pushToast && pushToast(title);

export function AppToaster() {
  const [toasts, setToasts] = useState([]);
  useEffect(() => {
    pushToast = (title) => {
      const id = crypto.randomUUID();
      setToasts((t) => [...t, { id, title }]);
      setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 2600);
    };
    return () => { pushToast = null; };
  }, []);
  if (!toasts.length) return null;
  return (
    <Flex position="fixed" left="0" right="0" bottom="calc(96px + env(safe-area-inset-bottom))"
      zIndex={2147483400} direction="column" align="center" gap="2" pointerEvents="none" data-testid="app-toaster">
      {toasts.map((t) => (
        <Flex key={t.id} align="center" gap="2" bg={colors.textPrimary} color="white" px="4" py="2.5"
          borderRadius="full" boxShadow="0 8px 24px rgba(0,0,0,0.25)" css={{ animation: "qaFadeIn 0.18s ease" }}
          data-testid="app-toast">
          <Icon as={CheckCircle2} boxSize="4" color="#7FD1C7" />
          <Text fontSize="sm" fontWeight="600">{t.title}</Text>
        </Flex>
      ))}
    </Flex>
  );
}
